// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Messages area */
.chat-messages {
    flex: 1;
    padding: 15px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
}

/* Individual messages */
.message {
    margin-bottom: 12px;
    max-width: 80%;
    padding: 10px 15px;
    border-radius: 18px;
    line-height: 1.4;
    font-size: 15px;
}

.message.user {
    align-self: flex-end;
    background-color: #d1e7dd;
    color: #2c3e50;
}

.message.user .ts {
    font-size: 10px;
    color: #8a8d91;
}

.message.assistant {
    align-self: flex-start;
    background-color: #f1f2f6;
    color: #2c3e50;
}

.message.typing {
    align-self: center;
    background-color: #ffffff;
    color: #a8b9c7;
    display: inline-block;
    width: 150px;
    /* adjust as needed */
    text-align: left;
    /* or center based on your layout */
    overflow: hidden;
    white-space: nowrap;
    padding-bottom: 30px;
}

/* Assistant formatting */
.message.assistant h1 {
    font-size: 1.2em;
}

.message.assistant h2 {
    margin-top: 10px;
    font-size: 1em;
}

.message.assistant ul,
.message.assistant ol,
.logs ul,
.logs ol {
    margin-top: 10px;
    list-style-type: square;
    margin-inline-start: 34px;
}

.message.assistant ul li,
.message.assistant ol li {
    list-style-type: square;
    font-size: 13px;
    line-height: 1.5em;
    margin-bottom: 5px;
}

.message.assistant>div>p:last-child {
    margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/css/message.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA,wBAAwB;AACxB;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,mCAAmC;IACnC,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA,yBAAyB;AACzB;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;;;IAII,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;;IAEI,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["/* Messages area */\n.chat-messages {\n    flex: 1;\n    padding: 15px;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n}\n\n/* Individual messages */\n.message {\n    margin-bottom: 12px;\n    max-width: 80%;\n    padding: 10px 15px;\n    border-radius: 18px;\n    line-height: 1.4;\n    font-size: 15px;\n}\n\n.message.user {\n    align-self: flex-end;\n    background-color: #d1e7dd;\n    color: #2c3e50;\n}\n\n.message.user .ts {\n    font-size: 10px;\n    color: #8a8d91;\n}\n\n.message.assistant {\n    align-self: flex-start;\n    background-color: #f1f2f6;\n    color: #2c3e50;\n}\n\n.message.typing {\n    align-self: center;\n    background-color: #ffffff;\n    color: #a8b9c7;\n    display: inline-block;\n    width: 150px;\n    /* adjust as needed */\n    text-align: left;\n    /* or center based on your layout */\n    overflow: hidden;\n    white-space: nowrap;\n    padding-bottom: 30px;\n}\n\n/* Assistant formatting */\n.message.assistant h1 {\n    font-size: 1.2em;\n}\n\n.message.assistant h2 {\n    margin-top: 10px;\n    font-size: 1em;\n}\n\n.message.assistant ul,\n.message.assistant ol,\n.logs ul,\n.logs ol {\n    margin-top: 10px;\n    list-style-type: square;\n    margin-inline-start: 34px;\n}\n\n.message.assistant ul li,\n.message.assistant ol li {\n    list-style-type: square;\n    font-size: 13px;\n    line-height: 1.5em;\n    margin-bottom: 5px;\n}\n\n.message.assistant>div>p:last-child {\n    margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
